module.exports = __webpack_public_path__ + "static/media/中高競技スキー部.ddeb5fd8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon/exhibition/中高競技スキー部.png
// module id = 313
// module chunks = 10